import { ModulesMap } from '@/config/data/modulesMaps'
import ApiModule from '@/services/apiModule.js'

export default class WorksServicePaymentRateNormsApi extends ApiModule {
	constructor() {
		super(ModulesMap.WORKS_SERVICE_PAYMENT_RATE_NORMS, {
			entity: 'works_service_payment_rates_norms',
		})
	}
}
